import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage} from '../../../../libs/shared/core/src/helpers/internationalization/message';
import {Avatar} from '../../../../libs/shared/ui/src/components/avatar/avatar';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface AdminSetupGuideHelpCardAvatarProps {
  index: number;
  imageSrc: string;
}

/*
 * Style.
 */

const StyledAvatar = styled(Avatar)<{$index: number}>`
  overflow: hidden;
  position: relative;
  /* This introduces a class for each avatar, but this is okay since in practice there are only a few avatars. */
  left: ${(p) => -4 * p.$index}px;
`;

const StyledImage = styled.img`
  width: 24px;
  height: 24px;
`;

/*
 * Component.
 */

export const AdminSetupGuideHelpCardAvatar: FC<AdminSetupGuideHelpCardAvatarProps> = (props) => {
  const theme = useUserTheme();
  const localize = useLocalize();

  return (
    <StyledAvatar size={24} borderColor={theme.greys.white} $index={props.index}>
      <StyledImage
        src={props.imageSrc}
        alt={localize(
          defineMessage({id: 'admin-setup-guide-help-card-avatar-alt-text', message: 'Help card avatar'}),
        )}
      />
    </StyledAvatar>
  );
};
